import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";

import { EligibilityRequirements } from "../steps/EligibilityRequirements/EligibilityRequirements";
import {
  OnboardingContext,
  OnboardingModuleEligibilityRequirements,
  OnboardingStep
} from "../types";
import { selectorIsAllRequirementsComplete } from "../../Requirements/selectors/selectorIsAllRequirementsComplete";

const getStatus = (requirements: IRequirementResponse[]) => {
  if (selectorIsAllRequirementsComplete(requirements)) {
    return "Complete";
  }

  return "None";
};

export const getEligibilityRequirementsStepConfig = (
  _: OnboardingModuleEligibilityRequirements,
  __: OnboardingContext,
  requirements?: IRequirementResponse[]
): OnboardingStep | null => {
  const hasRequirements = !!requirements?.length;

  if (!hasRequirements) {
    return null;
  }

  const slug = "requirements";

  const status = getStatus(requirements);

  return {
    title: "Additional client requirements",
    slug,
    component: EligibilityRequirements,

    status,
    result: {
      Complete: {
        title: "Your eligibility requirements are complete",
        description:
          "Your eligibility requirements are complete. Your eligibility requirements from your clients are complete. If additional requirements are needed in the future, these tasks will appear on your “Get started” homepage. Click continue for the next step."
      }
    }
  };
};
